import * as yup from 'yup';
import { Risk, values } from '../enums';

export const RiskRatingSchema = yup.object({
  risk: yup.mixed<Risk>().oneOf(values(Risk)).required(),
  note: yup
    .string()
    .nullable()
    .when('risk', {
      is: (risk: Risk) => risk === Risk.NONE || risk === Risk.HIGH,
      then: yup.string().required('description.required'),
      otherwise: yup.string().optional().nullable(),
    }),
});

export type IRiskRating = {
  risk: Risk;
  note: string;
};
